import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { CMSPath } from "../../../config/constant";
import { scrollToTop } from "../../../JS/scrollToTop";

const Activities6 = (props) => {

    const { t } = props;

    
 
useEffect(()=>{
    scrollToTop()
},[])

    return (
        <>
            <header className="inner-pages w-footer subpages">
                <a className="button-back" onClick={() => props.handleGoBack()}></a>
                <div className="heading align-center">
                    <div class="splash-brand">
                        <img src={`${CMSPath}${props.logo}`} />
                    </div>
                </div>
            </header>

            <section class="widgets spa-listing spa-details completed">
                <div class="widget-header">
                    {props.currentWidgetObj.widgetHeaderImageUrl && (
                        <div class="widget-header-img">
                            <img
                                src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                                alt={props.currentWidgetObj.displayName}
                            />
                        </div>
                    )}
                    <div class="widget-header-title">
                        {t(`activityBooking.headingSuccess`)}
                    </div>
                    <div class="widget-header-subtitle">
                        {props.updateReservationDetails ? t(`activityBooking.sub_headingSuccessUpdated`) : t(`activityBooking.sub_headingSuccess`)}
                    </div>
                </div>



                <div class="widgets">
                    <div class="row margin-bottom-2">
                        <div class="row">
                            <div class="col">
                                <div class="detail-body stay-body">
                                    <div class="stay-info-details">
                                        <div class="stay-info-body">

                                            <p style={{ whiteSpace: "pre-line" }}>
                                                {t("activityBooking.success_page_body").replace("#ACTIVITY_NAME", props.bookingData.selectedActivity.serviceName)}
                                            </p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-controls">
                                <button
                                    onClick={() => {
                                        props.handleGoBack();
                                    }}
                                >
                                    {t(`activityBooking.okay`)}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
};

const mapStateToProps = (state) => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        logo: state.store.home.currentDuration.brandingInfo
            ? state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl
            : "",
    };
};

export default connect(
    mapStateToProps,
    {}
)(withTranslation("translations")(Activities6));
